import { BRAND, BRAND_DARK, BRAND_LIGHT } from "@/shared/constants.js";

export const Toggle = ({ value, onChange, label, description, disabled }) => (
  <div onClick={disabled ? undefined : () => onChange(!value)} style={{
    display: "flex", alignItems: "flex-start", gap: 10, padding: "10px 14px",
    background: value ? BRAND_LIGHT : "#f7f7f5", borderRadius: 10,
    border: `1px solid ${value ? BRAND : "transparent"}`, cursor: disabled ? "default" : "pointer",
    opacity: disabled ? 0.6 : 1,
    transition: "all 0.2s", marginBottom: 8,
  }}>
    <div style={{
      width: 18, height: 18, borderRadius: 4, border: `1.5px solid ${value ? BRAND : "#bbb"}`,
      background: value ? BRAND : "#fff", display: "flex", alignItems: "center", justifyContent: "center",
      transition: "all 0.2s", flexShrink: 0, marginTop: 1,
    }}>
      {value && <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ width: 11, height: 11 }}><polyline points="20 6 9 17 4 12" /></svg>}
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: 13, color: value ? BRAND_DARK : "#555", fontFamily: "'DM Sans', sans-serif", lineHeight: 1.4 }}>{label}</div>
      {description && (
        <div style={{ fontSize: 11, color: "#888", marginTop: 2, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.4 }}>{description}</div>
      )}
    </div>
  </div>
);
